import axios from "axios";

const HOME_SECTION_API_URL = `${process.env.REACT_APP_API_URL}/home`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all home sections
export const fetchHomeSections = async () => {
  const response = await axios.get(`${HOME_SECTION_API_URL}/home-section`, { headers: customHeaders });
  return response.data;
};

// Create a new home section
export const addHomeSection = async (newHomeSection: { title: string; description: string; is_active: boolean; image?: string }) => {
  const response = await axios.post(HOME_SECTION_API_URL, newHomeSection, { 
    headers: customHeaders
  });
  return response.data;
};

// Edit an existing home section
export const updateHomeSection = async ( updatedHomeSection: { title: string; description: string; is_active: boolean; image?: string }) => {
  const response = await axios.put(`${HOME_SECTION_API_URL}`, updatedHomeSection, { 
    headers: customHeaders
  });
  return response.data;
};
